import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { fetchCountriesIfNeeded, fetchTimezonesIfNeeded, updateUserLocal } from 'common/ducks/user';
import { goToSubstep } from 'registration/creative/ducks';
import { fetchAccountsIfNeeded } from 'common/ducks/payout';
import Substep2_1 from 'registration/creative/components/substep2_1';

const mapStateToProps = ({
  user, creativeRegistration: { reviewing, registrationReopenedAt, registrationSubmittedAt }, payout
}) => ({
  user,
  reviewing,
  registrationReopenedAt,
  registrationSubmittedAt,
  payoutAccounts: payout.accounts
})

const mapDispatchToProps = (dispatch) => ({dispatch})

const mergeProps = (stateProps, {dispatch}) => {
  const { user, reviewing } = stateProps
  return {
    ...stateProps,
    ...bindActionCreators({
      fetchCountriesIfNeeded,
      fetchTimezonesIfNeeded,
      fetchPayoutAccounts: fetchAccountsIfNeeded,
      updateUserLocal,
      /* If smartphone method was chosen and user is on review phase,
         skip the verification step, since it would require a new magic
         link to be sent. */
      nextSubstep: partial(goToSubstep, (reviewing && user.mobileUpdatedSmart)? "profile":"verify")
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Substep2_1);



// WEBPACK FOOTER //
// ./registration/creative/containers/substep2_1.jsx